class TabGroup extends HTMLElement {
  /** @type {HTMLElement[]} */
  #tabs = [];
  /** @type {HTMLElement[]} */
  #panels = [];

  connectedCallback() {
    const bar = this.querySelector(':scope > .tabs-component__bar');
    const panelsContainer = this.querySelector(':scope > .tabs-component__panels');
    if (!bar || !panelsContainer) return;

    this.#panels = Array.from(panelsContainer.querySelectorAll(':scope > .tabs-component__panel'));
    if (this.#panels.length === 0) return;

    bar.replaceChildren();

    this.#tabs = this.#panels.map((panel, index) => {
      const label = panel.dataset.tabLabel || `Tab ${index + 1}`;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tabs-component__tab';
      button.setAttribute('role', 'tab');
      button.textContent = label;
      button.addEventListener('click', () => this.#activate(index));

      bar.appendChild(button);
      return button;
    });

    this.#activate(0);
  }

  /** @param {number} index */
  #activate(index) {
    this.#tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('tabs-component__tab--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.#panels.forEach((panel, i) => {
      panel.classList.toggle('tabs-component__panel--active', i === index);
    });
  }
}

if (!customElements.get('tab-group')) {
  customElements.define('tab-group', TabGroup);
}
